"use client";

import styled from "styled-components";

export const IconComponent = styled.span`
  & > svg {
    max-width: 40px;
    max-height: 40px;
    width: auto;
    height: auto;
  }

  & > svg > g {
    fill: var(--color-primary);
  }

  & > svg > path {
    fill: var(--color-primary);
  }
`;
